<template>
    <div :class="{transport:!isMobile,mtransport:isMobile,mobileCommon:isMobile}">
        <!-- 地址相关 -->
        <div>
            <p class="SubTitle pt40">{{ langPage['bov-commande-detail']['TXT_modepaiement'] }}</p>


            <div class="moyens">
                <div v-for="(item,index) of listPayTypes"
                     :key="index"
                     class="item"
                     @mouseover="moyens(item)"
                     :class="chooseType.type==item.type?'bg':'border'">
                    <img
                        class="check"
                        :src="chooseType.type==item.type?require('@/assets/img/Radio-on.svg'):require('@/assets/img/Radio-off.svg')"
                    />
                    {{ item.title }}
                    <span class="desc" @click="onClickShowDialog">
                        {{ item.desc ? item.desc : '' }}</span>
                </div>
                <p></p>
                <el-checkbox v-model="checked">
                    <div class="accepte el-link" v-html="langPage['v4-paiement']['TAREA_jaccepteles']"
                         @click="$router.push('/conditions/commonPage?type=cguv')"></div>
                </el-checkbox>
            </div>
        </div>
        <div class="opt">
            <!--            <p style="cursor: pointer" @click="$router.replace({path:'/panier'})">{{ langPage['panier-livraisons']['TXT_retouraupanier'] }}</p>-->
            <div>
                <!--                <p>{{ langPage['v4-paiement']['TXT_vouspourrez'] }}</p>-->
                <!--                <button @click="sub">{{ langPage['edito-detail-fiche']['TXT_suivant'] }}</button>-->
            </div>
        </div>
        <!--        <bottom-nav/>-->
        <el-dialog
            :visible.sync="isShowHelp"
            :width="!isMobile?'800px':'100vw'"
            class="el-dialog-paiement">
            <div class="container" v-if="chooseType.type=='transfer'">
                <p class="title">{{ langPage['mobile-panier-resume']['BTN_paiement_virement'] }}</p>
                <p class="sub-title">{{ langPage['mobile-panier-resume']['TXT_virement_title'].toUpperCase() }}</p>
                <span class="dialog-span">{{ langPage['mobile-panier-resume']['TXT_virement_desc_1'] }}
        {{ langPage['mobile-panier-resume']['TXT_attention'] }}</span>
                <span class="dialog-span">{{ langPage['mobile-panier-resume']['TXT_virement_desc_3'] }}</span>
                <span class="dialog-span">{{ langPage['mobile-panier-resume']['TXT_virement_desc_4'] }}</span>
                <br>
                <span class="dialog-span">{{ langPage['v4-paiement']['TXT_nhesitezpas'] }}</span>
                <span class="dialog-span">{{ langPage['v4-paiement']['TXT_pourtoute'] }}</span>
            </div>
            <div class="container" v-if="['thirdPay_hero_Pay3X','thirdPay_hero_Pay30D'].includes(chooseType.type)">
                Si vous choisissez l’une des options de paiement Hero(paiement en
                3 fois), le traitement de votre commande peut être allongé de 24h/
                48h, et vous êtes susceptibles d'être contacté par la société Hero
                afin d'obtenir des informations complémentaires, nécessaires a la
                validation de votre demande de financement.
            </div>
        </el-dialog>
    </div>
</template>
<script>
// import
import BottomNav from "@/components/bottomNav";
let commonUtils = require('@/utils/common_utils');

export default {
    name: "transport",
    components: {BottomNav},
    watch: {
        checked(val) {
            this.sub();
        }
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            checked: true,
            choosePayIndex: 0,
            autreval: [
                "Je préfère organiser mon transport NEW",
                " J’enlève directement la marchandise"
            ],
            addrfrom: [
                {
                    title: "Numéro de carte ",
                    key: "a",
                    only: "true"
                },
                {
                    title: "Titulaire de la carte",
                    only: "true",
                    key: "b"
                },
                {
                    title: "Date d’expiration",
                    key: "c",
                    only: true
                },
                {
                    title: "Code de sécurité (CCV)",
                    key: "d",
                    // only: true
                    hidden: true
                }
            ],
            addrdata: [
                {
                    a: "1324567891022",
                    b: "Arnaud Durant",
                    c: "19/20",
                    d: "Expire le"
                }
            ],
            isShowHelp: false,
            isFranceAddress: false,//是否收货地址是法国
            listPayTypes: [
                {
                    type: 'thirdPay',
                    title: this.$langPage['mobile-panier-resume']['BTN_paiement_cb'],
                    desc: '',
                },
                {
                    type: 'transfer',
                    title: this.$langPage['mobile-panier-resume']['BTN_paiement_virement'],
                    desc: this.$langPage['mobile-panier-resume']['TXT_virement_title'],
                },
                {
                    type: 'thirdPay_amex',
                    title: this.$langPage['mobile-panier-resume']['BTN_paiement_cb'] + ' (American Express)',
                    desc: '',
                },
                {
                    type: 'thirdPay_v3',
                    title: this.$langPage['mobile-panier-resume']['BTN_paiement_cb'] + ' v3',
                    desc: '',
                },
            ],
            type_hero_3x: {
                type: 'thirdPay_hero_Pay3X',
                title: 'Paiement en 3 fois',
                desc: this.$langPage['mobile-panier-resume']['TXT_virement_title'],
            },
            type_hero_30D: {
                type: 'thirdPay_hero_Pay30D',
                title: 'Paiement à 30 jours',
                desc: this.$langPage['mobile-panier-resume']['TXT_virement_title'],
            },
            chooseType: {},
        };
    },
    computed: {
        langPage() {
            return this.$store.state['langPage']
        }
    },
    mounted() {
        this.$store.commit("set", {key: "stepData", value: 0.75});
        this.order_confirm = this.$store.state.order_confirm;
        this.chooseType = {...this.listPayTypes[0]};
        this.$forceUpdate();
        if ([10].includes(this.order_confirm.livraison.id_pays)
            && [10].includes(this.order_confirm.facturation.id_pays)) {
            this.isFranceAddress = true;
        }
        // this.isFranceAdress = ;
        this.getAvailablePaymentTypes();
        this.sub();
    },
    methods: {
        sub() {
            if (!this.checked) {
                return this.$message.error(this.langPage['panier-resume']['TXT_merciacceptecguv']);
            }
            let temp = this.$store.state.order_confirm;
            temp.pay_type = this.chooseType.type;
            this.$store.commit('set', {key: 'order_confirm', value: temp});
        },
        moyens(item) {
            this.chooseType = item;
            console.log('chooseType', this.chooseType.type)
            this.sub();
        },
        async getAvailablePaymentTypes() {
            console.log('totalNum22',this.order_confirm.totalNum);
            //等待tableCard组件里面计算金额计算结束
            await commonUtils.timeSleep(200);
            let res = await this.$api.order.get_available_payment_types({
                amount: Number(this.order_confirm.totalNum.totalTtcTotals).toFixed(2),
            });
            if (res.code != 0) return;
            let availablePaymentTypes = res.data.availablePaymentTypes;
            availablePaymentTypes.forEach(type => {
                if (type == 'Pay3X') {
                    this.listPayTypes.push(this.type_hero_3x);
                } else if (type == 'Pay30D') {
                    this.listPayTypes.push(this.type_hero_30D);
                }
            })
        },
        onClickShowDialog() {
            this.isShowHelp = true;
        }
    }
};
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Checkout/paiement.less">
</style>
